import bookApi from "../../../api/account/book";

const state = {
  list: {
    formatList: []
  }
};

const getters = {};

const mutations = {
  // 存首页的列表
  setLst(state, { data }) {
    state.list = data;
  },
  // 修改收藏状态
  collect(state, { data }) {
    console.log("favourites collect");
    console.log(state);
    console.log(data);
    state.list.list.find((v, i) => {
      if (v.housePropertyPOJO.propertyId == data.id) {
        state.list.list.splice(i, 1);
      }
    });
  }
};

const actions = {
  // 获取列表
  getLst({ state }, { params, callback }) {
    console.log(state);
    bookApi.getLstApi({ params, callback }, res => {
      callback(res);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/account/book.js